import { render, staticRenderFns } from "./ReportCompetency.vue?vue&type=template&id=a9d3483a&scoped=true"
import script from "./ReportCompetency.vue?vue&type=script&lang=js"
export * from "./ReportCompetency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d3483a",
  null
  
)

export default component.exports